import { render, staticRenderFns } from "./ModelPaidPictureCard.vue?vue&type=template&id=6a060143&scoped=true&"
import script from "./ModelPaidPictureCard.vue?vue&type=script&lang=js&"
export * from "./ModelPaidPictureCard.vue?vue&type=script&lang=js&"
import style0 from "./ModelPaidPictureCard.vue?vue&type=style&index=0&id=6a060143&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a060143",
  null
  
)

export default component.exports